const WordIcon = ({ width = '100%', height = '100%', ...props }: any) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.395406 0.395467C0.142232 0.648641 0 0.992019 0 1.35006V20.2501C0 20.6081 0.142232 20.9515 0.395406 21.2047C0.64858 21.4578 0.991958 21.6001 1.35 21.6001H14.85C15.208 21.6001 15.5514 21.4578 15.8046 21.2047C16.0578 20.9515 16.2 20.6081 16.2 20.2501V6.35451C16.1999 5.9965 16.0576 5.65318 15.8045 5.40006L10.8 0.395611C10.5469 0.14242 10.2036 0.000137496 9.84555 6.10352e-05H1.35C0.991958 6.10352e-05 0.64858 0.142293 0.395406 0.395467ZM1.35 1.35006H9.45V5.40006C9.45 5.7581 9.59223 6.10148 9.84541 6.35465C10.0986 6.60783 10.442 6.75006 10.8 6.75006H14.85V20.2501H1.35V1.35006ZM10.8 5.40006V2.30451L13.8955 5.40006H10.8ZM7.46463 16.3999H5.98463L4.74463 10.7999H5.96863L6.75263 15.1039L7.53663 10.7999H9.26463L10.0486 15.1039L10.8326 10.7999H12.0566L10.8166 16.3999H9.33663L8.40063 11.7759L7.46463 16.3999Z"
      fill="#3E92F7"
    />
  </svg>
)

export default WordIcon
